/**
 * Gemeinde entity model class
 *
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from './BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export class Country extends BaseModel {
    public id: number | null = null;
    public country_id: number | null = null;
    public un_id: number | null = null;
    public iso2_id: string | null = null;
    public iso3_id: string | null = null;
    public short_name_de: string | null = null;
    public short_name_fr: string | null = null;
    public short_name_it: string | null = null;
    public short_name_en: string | null = null;
    public official_name_de: string | null = null;
    public official_name_fr: string | null = null;
    public official_name_it: string | null = null;
    public continent: number | null = null;
    public region: number | null = null;
    public un_entry_date: Dayjs | null = null;
    public date_of_change: Dayjs | null = null;
    public recognized_date: Dayjs | null = null;
    public remark_fr: string | null = null;
    public remark_de: string | null = null;
    public remark_it: string | null = null;
    public area_state: number | null = null;
    public state: boolean | null = null;
    public un_member: boolean | null = null;
    public recognized_ch: boolean | null = null;
    public entry_valid: boolean | null = null;


    mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            country_id: (id) => (Number(id) > 0 ? Number(id) : null),
            un_entry_date: (value) => dayjs(value),
            date_of_change: (value) => dayjs(value),
            recognized_date: (value) => dayjs(value)
        };
    }

    getClassName(): string {
        return 'Country';
    }

}

export class CountryCollection extends BaseCollection<Country> {
    protected modelCls = Country;

    public getModelClassName(): string {
        return 'Country';
    }
}
